import SidebarHeader from '@/components/Modals/Sidebar/components/SidebarHeader';
import useDynamicSidebarHeader from '@/components/Modals/Sidebar/hooks/useDynamicSidebarHeader';
import { SwitchToYearlyTabs } from './tabs';
const SwitchToYearlyModalHeader = () => {
  // Used for controlling the sidebar header when specific screens are active
  useDynamicSidebarHeader({
    dynamicTabs: [...SwitchToYearlyTabs]
  });
  return <SidebarHeader data-sentry-element="SidebarHeader" data-sentry-component="SwitchToYearlyModalHeader" data-sentry-source-file="header.tsx" />;
};
export { SwitchToYearlyModalHeader };